module.exports = __webpack_public_path__ + "static/media/custom-table-c-TR10.91cbeade.png";